import React from 'react';
import './FormButton.css';

/**
 * FormButton
 *
 * A reusable button for forms and CTAs.
 *
 * @param {React.ReactNode}  children      - Button label / content
 * @param {'button'|'submit'|'reset'} type - HTML button type (default: 'button')
 * @param {'primary'|'secondary'|'ghost'}  variant   - Visual style (default: 'primary')
 * @param {boolean}          fullWidth     - Stretch to 100% width (default: false)
 * @param {boolean}          loading       - Show spinner and disable interactions
 * @param {string}           loadingText   - Label shown while loading (default: children)
 * @param {boolean}          disabled      - Disable the button
 * @param {function}         onClick       - Click handler
 * @param {string}           className     - Extra CSS classes
 */
const FormButton = ({
    children,
    type = 'button',
    variant = 'primary',
    fullWidth = false,
    loading = false,
    loadingText,
    disabled = false,
    onClick,
    className = '',
}) => {
    const classes = [
        'fb-btn',
        `fb-btn--${variant}`,
        fullWidth ? 'fb-btn--full-width' : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <button
            className={classes}
            type={type}
            disabled={disabled || loading}
            onClick={onClick}
        >
            {loading && <span className="fb-btn__spinner" />}
            {loading ? (loadingText ?? children) : children}
        </button>
    );
};

export default FormButton;
